import { createRouter, createWebHashHistory } from 'vue-router'
import { isAuthenticated } from '../utils/auth'
import { PLT_CONVERTER_ROUTE_NAME, PLT_CONVERTER_ROUTE_PATH } from '../config/pltConverterRoute'
import LoginView from '../views/LoginView.vue'
import MainLayout from '../layouts/MainLayout.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
    meta: { title: '登录', public: true }
  },
  {
    path: '/login',
    redirect: '/'
  },
  {
    path: '/app',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: { name: 'home' } },
      {
        path: 'ops-dashboard',
        name: 'opsDashboard',
        component: () =>
          import(/* webpackChunkName: "ops-dashboard" */ '../views/OpsDashboardView.vue'),
        meta: { title: '运营数据看板' }
      },
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
        meta: { title: '款式列表' }
      },
      {
        path: 'customers',
        name: 'customerList',
        component: () => import(/* webpackChunkName: "customers" */ '../views/CustomerListView.vue'),
        meta: { title: '客户列表' }
      },
      {
        path: 'customers/:id',
        name: 'customerDetail',
        component: () => import(/* webpackChunkName: "customers" */ '../views/CustomerDetailView.vue'),
        meta: { title: '客户详情' }
      },
      {
        path: 'work-review',
        name: 'workReview',
        component: () => import(/* webpackChunkName: "work-review" */ '../views/WorkReviewListView.vue'),
        meta: { title: '作业审核' }
      },
      {
        path: 'orders',
        name: 'orderList',
        component: () => import(/* webpackChunkName: "orders" */ '../views/OrderListView.vue'),
        meta: { title: '订单列表' }
      },
      {
        path: 'refund-review',
        name: 'refundReview',
        component: () =>
          import(/* webpackChunkName: "refund-review" */ '../views/RefundReviewListView.vue'),
        meta: { title: '退款审核' }
      },
      {
        path: 'dicts',
        name: 'dictList',
        component: () => import(/* webpackChunkName: "dicts" */ '../views/DictListView.vue'),
        meta: { title: '系统字典' }
      },
      {
        path: 'plt-converter',
        name: 'pltConverterApp',
        component: () => import(/* webpackChunkName: "plt-converter" */ '../views/PltConverterView.vue'),
        meta: { title: 'PLT转PDF', embedInApp: true }
      },
      {
        path: 'style/new',
        name: 'styleNew',
        component: () => import(/* webpackChunkName: "styles" */ '../views/StyleCreateView.vue'),
        meta: { title: '新增款式' }
      },
      {
        path: 'style/:id/edit',
        name: 'styleEdit',
        component: () => import(/* webpackChunkName: "styles" */ '../views/StyleCreateView.vue'),
        meta: { title: '编辑款式' }
      },
      {
        path: 'style/:id',
        name: 'styleDetail',
        component: () => import(/* webpackChunkName: "styles" */ '../views/StyleDetailView.vue'),
        meta: { title: '款式详情' }
      },
      {
        path: 'preview-styles',
        name: 'previewStyleList',
        component: () =>
          import(/* webpackChunkName: "preview-styles" */ '../views/PreviewStyleListView.vue'),
        meta: { title: '预告款列表' }
      },
      {
        path: 'preview-style/new',
        name: 'previewStyleNew',
        component: () =>
          import(/* webpackChunkName: "preview-styles" */ '../views/PreviewStyleCreateView.vue'),
        meta: { title: '新增预告款' }
      },
      {
        path: 'preview-style/:id/edit',
        name: 'previewStyleEdit',
        component: () =>
          import(/* webpackChunkName: "preview-styles" */ '../views/PreviewStyleCreateView.vue'),
        meta: { title: '编辑预告款' }
      },
      {
        path: 'preview-style/:id',
        name: 'previewStyleDetail',
        component: () =>
          import(/* webpackChunkName: "preview-styles" */ '../views/PreviewStyleDetailView.vue'),
        meta: { title: '预告款详情' }
      },
      {
        path: 'preview-style-review',
        name: 'previewStyleReview',
        component: () =>
          import(/* webpackChunkName: "preview-styles" */ '../views/PreviewStyleAuditListView.vue'),
        meta: { title: '预告款审核/试板' }
      }
    ]
  },
  {
    path: PLT_CONVERTER_ROUTE_PATH,
    name: PLT_CONVERTER_ROUTE_NAME,
    component: () => import(/* webpackChunkName: "plt-converter" */ '../views/PltConverterView.vue'),
    meta: { title: 'PLT 转 PDF', public: true }
  },
  /** 旧登录跳转路径，兼容历史链接 */
  { path: '/styles', redirect: { name: 'home' } }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  const needsAuth = to.matched.some((record) => record.meta.requiresAuth)
  if (needsAuth && !isAuthenticated()) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && isAuthenticated() && !to.query.redirect) {
    return { name: 'home' }
  }
  return true
})

export default router
